export const permissions = {
    web: {
        name: "web",
        groups: [
            {
                name: "Stores",
                isChecked: false,
                permissions: [
                    {
                        name: "1.1 View Stores List",
                        u_name: "stores.view",
                        isChecked: false,
                    },
                    {
                        name: "1.2 View Products at Stores",
                        u_name: "stores.products.view",
                        isChecked: false,
                    },
                    {
                        name: "1.3 Edit Product Information",
                        u_name: "stores.products.edit",
                        isChecked: false,
                    },
                    {
                        name: "1.4 View Devices at Stores",
                        u_name: "stores.device.view",
                        isChecked: false,
                    },
                    {
                        name: "1.5 View Devices Details",
                        u_name: "stores.device.detail",
                        isChecked: false,
                    },
                    {
                        name: "1.6 Edit Devices Information",
                        u_name: "stores.device.edit",
                        isChecked: false,
                    },
                ]
            },
            {
                name: "Warehouse",
                isChecked: false,
                permissions: [
                    {
                        name: "2.1 View Products at Warehouse",
                        u_name: "warehouse.products.view",
                        isChecked: false,
                    },
                    {
                        name: "2.2 Add Products at Warehouse",
                        u_name: "warehouse.products.create",
                        isChecked: false,
                    },
                    {
                        name: "2.3 Edit Products at Warehouse",
                        u_name: "warehouse.products.edit",
                        isChecked: false,
                    },
                ]
            },
            {
                name: "Alerts & Notification",
                isChecked: false,
                permissions: [
                    {
                        name: "3.1 View Alerts",
                        u_name: "alerts.view",
                        isChecked: false,
                    },
                    {
                        name: "3.2 Update Alerts",
                        u_name: "alerts.edit",
                        isChecked: false,
                    },
                    {
                        name: "3.2 View Notification",
                        u_name: "notifications.view",
                        isChecked: false,
                    },
                ]
            },
            {
                name: "Bulk Stock Upload",
                isChecked: false,
                permissions: [
                    {
                        name: "4.1 Upload Products for Stores",
                        u_name: "bulk.stocks.stores",
                        isChecked: false,
                    },
                    {
                        name: "4.2 Upload Products for Warehouse",
                        u_name: "bulk.stocks.warehouses",
                        isChecked: false,
                    }
                ]
            },
            {
                name: "Transit Stock",
                isChecked: false,
                permissions: [
                    {
                        name: "5.1 View In-Transit Shipments",
                        u_name: "transit.view",
                        isChecked: false,
                    },
                    {
                        name: "5.2 View Shipment details",
                        u_name: "transit.detail",
                        isChecked: false,
                    }
                ]
            },
            {
                name: "Analytics",
                isChecked: false,
                permissions: [
                    {
                        name: "6.1 View Analytics",
                        u_name: "analytics.view",
                        isChecked: false,
                    }
                ]
            },
            {
                name: "Sales & Reports",
                isChecked: false,
                permissions: [
                    {
                        name: "7.1 View Reports",
                        u_name: "sales.reports.view",
                        isChecked: false,
                    },
                    {
                        name: "7.2 Generate Custom Reports",
                        u_name: "sales.reports.generate",
                        isChecked: false,
                    }
                ]
            },
            {
                name: "Master Data",
                isChecked: false,
                permissions: [
                    {
                        name: "8.1 View Implant Types",
                        u_name: "master.products.view",
                        isChecked: false,
                    },
                    {
                        name: "8.2 Edit Implant Types",
                        u_name: "master.products.edit",
                        isChecked: false,
                    },
                    {
                        name: "8.3 View Locations",
                        u_name: "master.locations.view",
                        isChecked: false,
                    },
                    {
                        name: "8.4 Edit Locations",
                        u_name: "master.locations.edit",
                        isChecked: false,
                    },
                ]
            },
            {
                name: "Settings",
                isChecked: false,
                permissions: [
                    {
                        name: "9.1 View User Roles",
                        u_name: "settings.users.roles.view",
                        isChecked: false,
                    },
                    {
                        name: "9.2 Add/Edit/Remove User Roles",
                        u_name: "settings.users.roles.edit",
                        isChecked: false,
                    },
                    {
                        name: "9.3 View Users",
                        u_name: "settings.users.view",
                        isChecked: false,
                    },
                    {
                        name: "9.4 Add/Edit/Remove Users",
                        u_name: "settings.users.edit",
                        isChecked: false,
                    },
                ]
            },
        ],
    },

    hardware: {
        name: "hardware",
        groups: [
            {
                name: "Cabinet",
                isChecked: false,
                permissions: [
                    {
                        name: "1.1 View Cabinet Stock",
                        u_name: "cabinet.products.view",
                        isChecked: false,
                    },
                    {
                        name: "1.2 View Users",
                        u_name: "cabinet.users.view",
                        isChecked: false,
                    },
                    {
                        name: "1.3 Register User",
                        u_name: "cabinet.users.create",
                        isChecked: false,
                    },
                ]
            },
            {
                name: "Desktop",
                isChecked: false,
                permissions: [
                    {
                        name: "2.1 Consumption Marking",
                        u_name: "desktop.products.consume",
                        isChecked: false,
                    },
                    {
                        name: "2.2 Count Products",
                        u_name: "desktop.products.count",
                        isChecked: false,
                    },
                ]
            },
            {
                name: "Handheld",
                isChecked: false,
                permissions: [
                    {
                        name: "3.1 Consumption Marking",
                        u_name: "handheld.products.consume",
                        isChecked: false,
                    },
                    {
                        name: "3.2 Count Products",
                        u_name: "handheld.products.count",
                        isChecked: false,
                    },
                ]
            },
        ],
    },
}

export const clearPermissions = (type) => {
    permissions[type].groups.forEach((group) => {
        group.isChecked = false;

        group.permissions.forEach((permission) => {
            permission.isChecked = false
        })
    });
}